import React from 'react';
import { Grid } from 'semantic-ui-react';

import CompanyContainerRenewalGrid from '../renewal/grid';
import CompanyComponentTopBar from '../containers/top-bar';

const CompanyRenewalsPage = () => {
    return (
        <Grid>
            <CompanyComponentTopBar />
            <Grid.Row>
                <Grid.Column mobile={16} >
                    <CompanyContainerRenewalGrid />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default CompanyRenewalsPage;